import React, { useContext } from "react";
import { GlobalDataContext } from "../context/context";
import TransparentHeader from "../components/global/TransparentHeader";
import BaseLayout from "../components/global/BaseLayout";


function OurVideos() {
    const { rpdata } = useContext(GlobalDataContext);
    return (
        <BaseLayout PageName="Our Videos">
            <div className="md:max-w-full w-full">
                <TransparentHeader
                    headertitle="Videos"
                    Subheader="Videos"
                    bgimg={`${rpdata?.stock?.[3]}`}
                />
            </div>
            <div className="w-4/5 mx-auto py-[100px]">
                <h1 className="text-center pb-10"> Our Videos</h1>
                <div className="elfsight-app-cade6d14-9637-4e20-8e31-8bf7428fd862"></div>
            </div>
        </BaseLayout>
    );
}

export default OurVideos;